import axiosInstance from "../config/AxiosConfig";

export const authRepository = {
  login: async (data) => {
    return await axiosInstance.post("/auth/login", data);
  },
};
